import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const CommentBubble = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M16 2.00002C8.28002 2.00002 2.00002 8.28002 2.00002 16C2.00002 18.122 2.46102 20.155 3.37002 22.048L2.01902 28.804C2.00602 28.867 1.99902 28.933 1.99902 29C1.99902 29.552 2.44702 30 2.99902 30C3.06602 30 3.13202 29.993 3.19502 29.98L9.95102 28.629C11.844 29.539 13.877 29.999 15.999 29.999C23.719 29.999 29.999 23.719 29.999 15.999C29.999 8.27902 23.719 1.99902 15.999 1.99902L16 2.00002ZM16 28C14.079 28 12.244 27.56 10.545 26.692C10.403 26.619 10.247 26.582 10.09 26.582C10.025 26.582 9.95902 26.588 9.89402 26.601L4.27502 27.725L5.39902 22.106C5.44302 21.885 5.41202 21.655 5.30902 21.455C4.44102 19.757 4.00102 17.922 4.00102 16C4.00102 9.38302 9.38402 4.00002 16.001 4.00002C22.618 4.00002 28.001 9.38302 28.001 16C28.001 22.617 22.618 28 16.001 28H16Z" />
	</svg>
);

export default CommentBubble;
